
import {createContext, useState} from 'react'

const Context = createContext()

export const LogContextProvider = ({children}) => {
 const [allLogs, setAllLogs] = useState([])
 const [logs, setLogs] = useState([]);
 const [log, setLog] = useState({})
 const [loading, setLoading] = useState(false);
 const [message, setMessage] = useState({
  message: '',
  status: 200
 })


 return <Context.Provider value={{allLogs, setAllLogs, logs, setLogs, log, setLog, message, setMessage, loading, setLoading}}>
  {children}
 </Context.Provider>
}
export default Context